document.addEventListener('DOMContentLoaded', function () {
  const slider = document.querySelector('.icon-slider-dtc');
  if (slider) {
      const slides = Array.from(slider.querySelectorAll('.custom-icon-block-dtc'));
      const wrapper = slider.querySelector('.slider-wrapper');
      const prevButton = slider.querySelector('.slider-prev');
      const nextButton = slider.querySelector('.slider-next');
      const speed = slider.dataset.sliderSpeed ? parseInt(slider.dataset.sliderSpeed, 10) * 1000 : 7000;
      let currentIndex = 1;
      const firstClone = slides[0].cloneNode(true);
      const lastClone = slides[slides.length - 1].cloneNode(true);

      wrapper.insertBefore(lastClone, slides[0]);
      wrapper.appendChild(firstClone);

      const updatedSlides = wrapper.querySelectorAll('.custom-icon-block-dtc');
      const totalSlides = updatedSlides.length;

      function getVisibleSlides() {
          if (window.innerWidth <= 768) return 1;
          if (window.innerWidth <= 1164) return 2;
          return Math.min(slides.length, 3); 
      }

      function updateSliderPosition(animate = true) {
          const visibleSlides = getVisibleSlides();
          const offset = -currentIndex * (100 / visibleSlides);

          wrapper.style.transition = animate ? 'transform 0.5s ease' : 'none';
          wrapper.style.transform = `translateX(${offset}%)`;
      }

      function nextSlide() {
          const visibleSlides = getVisibleSlides();
          currentIndex++;
          updateSliderPosition();
          if (currentIndex >= totalSlides - 1) {
              setTimeout(() => {
                  currentIndex = 1;
                  updateSliderPosition(false);
              }, 500); 
          }
      }

      function prevSlide() {
          const visibleSlides = getVisibleSlides();
          currentIndex--;
          updateSliderPosition();
          if (currentIndex <= 0) {
              setTimeout(() => {
                  currentIndex = totalSlides - 2;
                  updateSliderPosition(false);
              }, 500); 
          }
      }

      const interval = setInterval(nextSlide, speed);

      if (prevButton && nextButton) {
          prevButton.addEventListener('click', () => {
              clearInterval(interval);
              prevSlide();
          });
          nextButton.addEventListener('click', () => {
              clearInterval(interval);
              nextSlide();
          });
      }
      window.addEventListener('resize', updateSliderPosition);
      updateSliderPosition(false); 
  }
});
